







import { Component, Vue, Prop } from 'vue-property-decorator';
import { TransceiversApi } from '@/api';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {},
})
export default class RebootTransceiver extends Vue {
	@Prop(String)
	public type: string;
	@Prop(Number)
	public transceiverId: number;
	@Prop({ default: false })
	public block!: boolean;

	public async reboot() {
		const transceiverId = this.transceiverId;

		let response;
		try {
			const api = new TransceiversApi();
			response = await api.rebootTransceiver(parseInt(transceiverId, 10));
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Reboot Transceiver', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
		if (this.type === '01' || this.type === '02' || this.type === '03' || this.type === '04') {
			new Toast().makeToast(
				'The transceiver has been updated to reboot on the next packet which may take an hour',
				'Rebooting',
				'success',
			);
		} else {
			new Toast().makeToast('The transceiver reboot message has been sent', 'Rebooting', 'success');
		}
	}
}
